<script>
import Loading from "@/components/layout/Loading.vue";
import {toDate} from "@/utils/time.js";
import defaultAvatar from "@/assets/img/intranet/header/icono-header-btn-contacto.svg"
import { EventBus } from '@/eventBus';
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      reconocimiento: {
        id_reconocimiento: ""
      },
      defaultAvatar:defaultAvatar
    };
  },
  components: {
    Loading,
  },
  methods: {
    toDate(date) {
      return toDate(date);
    },
    reconoceDetail(rec) {
      this.reconocimiento = rec;
    },
    sendMessage(user) {
      EventBus.$emit("actionFn", { fn:"enviarMensaje", params:user});
    }
  },
};
</script>

<template>
  <section class="widget">
    <Loading v-if="loading" pixeles="100px" class="mb-3" />
    <div
      v-if="!loading"
      class="card card-custom card-custom-h-450 border-0 mb-3"
    >
      <div
        class="d-flex justify-content-between align-items-center p-3 pb-0 color-main"
      >
        <p class="d-flex align-items-center font-title font-700 mb-0">
          <img
            height="40"
            src="@/assets/img/intranet/home/img-card-reconocer.png"
          />
          <span>Reconocimientos</span>
        </p>
        <router-link class="font-title font-700 mb-0 color-main" to="/reconoce">
          Ver más
        </router-link>
      </div>
      <div v-if="data.length !== 0" class="card-body scroll max-h-400">
        <div
          v-for="item in data"
          :key="item.id_reconocimiento"
          class="d-flex align-items-start card-shadow-light rounded p-2 mb-3 align-items-center"
        >
          <div class="flex-shrink-0">
            <img
              width="40"
              height="40"
              class="img-object-cover rounded-circle"
              v-if="
                !item.imagen_perfil ||
                !/.jpg|.jpeg|.png/.test(item.imagen_perfil)
              "
              src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
            />
            <img
              v-else
              width="40"
              height="40"
              class="img-object-cover rounded-circle"
              :src="item.imagen_perfil"
            />
          </div>
          <div class="flex-grow-1 ms-3">
            <p class="d-grid text-secondary mb-0">
              <strong>
                {{ capitalizeFirstLetter(item.reconocidos[0].primer_nombre) }}
                {{
                  capitalizeFirstLetter(item.reconocidos[0].apellido_paterno)
                }}
              </strong>
              <span class="text-secondary text-opacity-75 ellipsis-custom">
                Reconocido/a por:<br />
                <span class="color-main">
                  {{
                    capitalizeFirstLetter(
                      item.valor_comportamiento[0].valor.nombre_valor
                    )
                  }}
                </span>
              </span>
            </p>
          </div>
          <a
            href="javascript:"
            @click="reconoceDetail(item)"
            class="fs-4 color-main"
            data-bs-toggle="modal"
            data-bs-target="#reconoce-modal"
          >
            <font-awesome-icon
              icon="fa-solid fa-arrow-right-to-bracket"
            ></font-awesome-icon>
          </a>
            <!--
          <a href="javascript:" class="ms-2 fs-4 color-main" @click="sendMessage(item.reconocidos[0])" > 
              <font-awesome-icon
                icon="fa-solid fa-comment-dots"
              ></font-awesome-icon>
            </a>
            -->
        </div>
      </div>
      <div v-if="data.length === 0" class="card-body">
        <div
          class="alert alert-light text-center border mb-0 text-secondary text-opacity-75"
        >
          <font-awesome-icon icon="fa-solid fa-circle-info"></font-awesome-icon>
          Sin información
        </div>
      </div>
      <div
        class="modal fade"
        id="reconoce-modal"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Reconocimiento</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body" v-if="reconocimiento.id_reconocimiento !== ''">
              <div class="d-flex align-items-center mb-4">
            <img
              :src="reconocimiento.reconocedor[0]?.imagen_perfil || defaultAvatar"
              class="rounded-circle me-3"
              width="50"
              height="50"
              alt="Imagen del reconocedor"
            />
            <div>
              <p class="mb-0">
                <strong>{{ reconocimiento.reconocedor[0]?.primer_nombre }} {{ reconocimiento.reconocedor[0]?.apellido_paterno }}</strong>
              </p>
              <p class="mb-0 text-muted">Reconocedor</p>
            </div>
          </div>
          <div class="d-flex align-items-center mb-4">
            <img
              :src="reconocimiento.reconocidos[0]?.imagen_perfil || defaultAvatar"
              class="rounded-circle me-3"
              width="50"
              height="50"
              alt="Imagen del reconocido"
            />
            <div>
              <p class="mb-0">
                <strong>{{ reconocimiento.reconocidos[0]?.primer_nombre }} {{ reconocimiento.reconocidos[0]?.apellido_paterno }}</strong>
              </p>
              <p class="mb-0 text-muted">Reconocido</p>
            </div>
          </div>
          <div class="mb-3">
            <p>
              <strong>Valor Reconocido:</strong>
              {{ reconocimiento.valor_comportamiento[0]?.valor.nombre_valor }}
            </p>
          </div>
          <div class="mb-3">
            <p>
              <strong>Fecha del Reconocimiento:</strong>
              {{ toDate(reconocimiento.fecha_creacion) }}
            </p>
          </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
